import { Skeleton } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';

import { ContractParcellesPage } from '@contracts';

export const Route = createFileRoute(
  '/_app/os/contracts_/$contractId/parcelles',
)({
  component: ContractParcellesPage,
  pendingComponent: () => <Skeleton h="100%" width="100%" />,
});
